import apiClient from '@/plugins/axios'

export default {
  getKits() {
    return apiClient.get('kitcaptacao')
  },

  getKit(id) {
    return apiClient.get(`kitcaptacao/${id}`)
  },

  postKit(kit) {
    return apiClient.post(`kitcaptacao`, { kitcaptacao: kit })

  },

  putKit(id, kit) {
    return apiClient.put(`kitcaptacao/${id}`, { kitcaptacao: kit })

  },

  deleteKit(id) {
    return apiClient.delete(`kitcaptacao/${id}`)

  },

}


// WEBPACK FOOTER //
// ./src/views/Kits/_services/KitService.js